import { MissionPlanRoute } from "@dtm-frontend/shared/ui";

export type WeatherConditionsData = Weather | SimpleWeather;

export enum AnalysisResult {
    None = "NONE",
    Ok = "OK",
    Warning = "WARNING",
    Danger = "DANGER",
}

export enum WeatherErrorType {
    CannotGetWeatherConditions = "CannotGetWeatherConditions",
    CannotGetDarWeatherConditions = "CannotGetDarWeatherConditions",
}

export interface WeatherError {
    type: WeatherErrorType;
}

export interface WeatherCondition {
    min: string;
    max: string;
    avg: string;
    unit: string;
    analysisResult: AnalysisResult;
}

export interface WeatherPayloadData {
    route: MissionPlanRoute;
    hoursRangeBefore: number;
    hoursRangeAfter: number;
    missionStartTime: Date;
    missionEndTime?: Date;
}

export interface WeatherDetails {
    isWithinDtm?: boolean;
    forecastRefTime?: Date;
    weatherConditions: Weather[];
}

export interface Weather {
    time: string;
    temp?: WeatherCondition;
    dewPointTemperature?: WeatherCondition;
    pressureAmsl?: WeatherCondition;
    specHumidity?: WeatherCondition;
    relHumidity?: WeatherCondition;
    totalCloudCover?: WeatherCondition;
    lowCloudCover?: WeatherCondition;
    mediumCloudCover?: WeatherCondition;
    heightCloudCover?: WeatherCondition;
    cloudBase?: WeatherCondition;
    snow?: WeatherCondition;
    rain?: WeatherCondition;
    visibility?: WeatherCondition;
    windSpeed100Agl?: WeatherCondition;
    windDirection100Agl?: WeatherCondition;
    windSpeed10Agl?: WeatherCondition;
    windDirection10Agl?: WeatherCondition;
    kpi?: WeatherCondition;
    windGusts10Agl?: WeatherCondition;
    groundPressure?: WeatherCondition;
}

export interface SimpleWeather {
    windSpeed100Agl?: WeatherCondition;
    windDirection100Agl?: WeatherCondition;
    kpi?: WeatherCondition;
    temp?: WeatherCondition;
    relHumidity?: WeatherCondition;
    groundPressure?: WeatherCondition;
}

export interface SupportedWeatherResponseBody {
    supportedZones: [
        {
            zoneDesignator: string;
            forecastType: string;
        }
    ];
}

export enum WeatherViewMode {
    Basic = "Basic",
    Tabs = "Tabs",
    Hide = "Hide",
}

export interface DetailedWeatherConditions {
    lastMeasurementTime: string;
    cloud: Cloud;
    occurrence: Occurrence;
    pressure: Pressure;
    temperature: Temperature;
    wind: Wind;
}

export interface Cloud {
    totalCloudCover?: number;
    amountOfTheCloud?: number;
    lowClouds?: number;
    mediumClouds?: number;
    highClouds?: number;
    lowestCloud?: number;
}

export interface Occurrence {
    presentWeather?: number;
    pastWeather3h?: number;
    pastWeather6h?: number;
}

export interface Pressure {
    mslPressureHpa?: number;
    characteristicOfPressureTendency?: number;
    amountOfPressureTendency?: number;
    meanPressureAtStationLevelHpa?: number;
}

export interface Temperature {
    airTemperature?: number;
    dewPointTemperature?: number;
}

export interface Wind {
    windDirection?: number;
    windSpeed?: number;
    highestGust?: number;
    highestGust10m?: number;
}

export interface DetailedWeatherConditionsData {
    stationId?: string;
    stationName?: string;
    stationNumber?: number;
    longitude?: number;
    latitude?: number;
    altitude?: number;
    weatherConditions: DetailedWeatherConditions;
}
